import { ElectricBolt, Thermostat } from '@mui/icons-material'
import { EnergyData } from '../../types/charts'
import { DashboardViewProps, TemperatureStatWidgetConfig, TestViewProps, Widget } from './Widget'
import { Box } from '@mui/system'
import { sprintf } from 'sprintf-js'
import { TemperaturePortControl } from '../ports/TemperaturePortControl'
import { Trans } from 'react-i18next'

export class TemperatureStatWidget extends Widget<{ energy: EnergyData[] }, TemperatureStatWidgetConfig> {

  get Icon() {
    return ElectricBolt
  }

  get width() {
    return 2
  }

  get height() {
    return 3
  }

  get bgColor() {
    return 'forth.main'
  }

  get textColor() {
    return 'forth.contrastText'
  }

  temperatureControls(): TemperaturePortControl[] {
    return this.findControslByFilter(ctrl => ctrl.port.type === 'TEMPERATURE') as TemperaturePortControl[]
  }

  draw(props: DashboardViewProps): React.ReactElement {
    const temperature = this.temperatureControls()[0].getValue<number|null>('temperature')
    const error = this.temperatureControls()[0].getValue<number|null>('error')

    return (
      <Box data-cy={`box-${this.getName()}`} sx={{
        p: 2,
        display: 'grid',
        gridTemplateColumns: '3fr 1fr',
      }}>
        <Box sx={{ fontSize: '2rem', color: error ? 'error.main' : this.textColor }}>
          {error || temperature === undefined || temperature === null ? '—' : sprintf('%.1f', temperature)}
          <Box component="span" sx={{ fontSize: '1rem' }}> °C</Box>
        </Box>
        <Box sx={{ fontSize: '2rem', textAlign: 'center' }}><Thermostat/></Box>
        <Box sx={{ lineHeight: 1.3, fontSize: '0.75rem' }}>{this.getName()}</Box>
      </Box>
    )
  }

  drawTestView(props: TestViewProps) {
    return this.dashboardView({
      testing: true,
      refresh: () => null
    })
  }

  getTestingInfo(): React.ReactElement {
    return <Box sx={{ mt: 2 }}>
      <Trans>If you have connected more DS18B20 temperature sensors to the same port, sensors start working once they have been all added. In this case, you can skip this test.</Trans>
    </Box>
  }

}
